export function PremiumHeader() {
	return (
		<div className="mx-auto w-full" style={{ maxWidth: "calc(3 * 20rem + 2 * 0.5rem)" }}>
			<div className="relative border-2 border-sesh-primary/20 bg-base-dark px-8 py-10 text-center shadow-lg transition-all duration-300 hover:border-sesh-primary/30">
				<div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-base-dark px-6">
					<span className="text-xl uppercase tracking-widest text-sesh-primary">
						Premium
					</span>
				</div>
				<h1 className="mb-2 text-6xl font-black uppercase tracking-tight text-sesh-primary">
					Unlock the full power
				</h1>
				<h2 className="text-4xl font-black text-sesh-primary">
					of <span className="sesh-title font-extrabold">sesh</span>
				</h2>
				<div className="mx-auto mt-6 h-1 w-32 bg-sesh-primary/30 transition-all duration-300 group-hover:w-48 group-hover:bg-sesh-primary/50"></div>
			</div>
		</div>
	);
}
